import { useEffect } from 'react';

const SEO = ({ title, description, keywords, canonical, ogImage }) => {
  useEffect(() => {
    // Title
    if (title) document.title = title;

    // Meta tags
    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(name.startsWith('og:') || name.startsWith('twitter:') ? 'property' : 'name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);
    setMeta('og:title', title);
    setMeta('og:description', description);
    setMeta('og:type', 'website');
    setMeta('og:site_name', 'SecureSphere by Infuse.AI');
    setMeta('og:image', ogImage || '/infuse-logo.jpg');
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    setMeta('robots', 'index, follow');

    // Canonical
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) { link = document.createElement('link'); link.setAttribute('rel', 'canonical'); document.head.appendChild(link); }
      link.setAttribute('href', canonical);
    }

    // Structured data
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "SecureSphere",
      "applicationCategory": "SecurityApplication",
      "operatingSystem": "Web",
      "description": description || "Telco-grade enterprise security platform by Infuse.AI",
      "provider": {
        "@type": "Organization",
        "name": "Infuse Technologies",
        "url": "https://infuse-ai.in",
        "email": "info@infuse.net.in",
        "telephone": "+91-9599960663",
        "address": { "@type": "PostalAddress", "addressCountry": "IN" }
      }
    };

    let script = document.querySelector('script[data-seo="structured"]');
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute('data-seo', 'structured');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(structuredData);
  }, [title, description, keywords, canonical, ogImage]);

  return null;
};

export default SEO;
